
// Vue reactivity
import { computed, defineComponent } from 'vue';

// icons
import { arrowBackOutline, close, } from 'ionicons/icons';

// components
import { IonContent, IonGrid, IonRow, IonCol, IonCardContent, } from '@ionic/vue';

// composables
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';

export default defineComponent({
  name: 'TermsAndConditionsModal',
  props: ["type"],
  components: { IonContent, IonGrid, IonRow, IonCol, IonCardContent,
                },
  setup(props) {
    // 1. declare state variables (ref to make them reactive)
    const { t } = useI18n();
    const store = useStore();
    const settings = computed(() => store.state.settings);
    const { getLocalizedStr } = utils();

    // 3. return variables & methods to be used in template HTML
    return {
      // icons
      arrowBackOutline, close,

      // variables
      settings,

      // methods
      t, getLocalizedStr,
    }
  },
})
